import { ITEMS } from '@moba/shared';

/**
 * Ilustraciones SVG de los objetos de la tienda (64×64). Cada una va sobre un
 * fondo con el color del objeto (`ItemDef.color`), como las habilidades en
 * `abilityIcons.ts`. El caparazón de Koopa usa además su render 3D (Shop.ts).
 */

const METAL = 'url(#metal)';
const DEFS = `
  <linearGradient id="metal" x1="0" y1="0" x2="1" y2="1">
    <stop offset="0" stop-color="#f4f8ff"/><stop offset="0.5" stop-color="#b9c6d6"/><stop offset="1" stop-color="#6d7b8c"/>
  </linearGradient>
  <linearGradient id="gold" x1="0" y1="0" x2="1" y2="1">
    <stop offset="0" stop-color="#fff2b8"/><stop offset="0.5" stop-color="#f2b53b"/><stop offset="1" stop-color="#9a6114"/>
  </linearGradient>
  <linearGradient id="leather" x1="0" y1="0" x2="0" y2="1">
    <stop offset="0" stop-color="#c98a52"/><stop offset="1" stop-color="#7a4a24"/>
  </linearGradient>
  <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
    <feDropShadow dx="0" dy="1.5" stdDeviation="1.2" flood-color="#000" flood-opacity="0.55"/>
  </filter>`;

const ART: Record<string, string> = {
  'short-sword': `
    <path d="M44 9 L55 9 L55 20 L30 45 L19 34 Z" fill="${METAL}" stroke="#2b3542" stroke-width="1.5"/>
    <path d="M47 12 L52 12 L27 37 L25 35 Z" fill="#fff" opacity="0.55"/>
    <path d="M14 33 L31 50 L27 54 L10 37 Z" fill="url(#gold)" stroke="#5a3a10" stroke-width="1.5"/>
    <path d="M18 46 L9 55" stroke="url(#leather)" stroke-width="6" stroke-linecap="round"/>
    <circle cx="8" cy="56" r="3.4" fill="url(#gold)" stroke="#5a3a10" stroke-width="1.2"/>`,
  'leather-armor': `
    <path d="M18 12 L26 9 Q32 15 38 9 L46 12 L54 22 L47 28 L46 54 L18 54 L17 28 L10 22 Z" fill="url(#leather)" stroke="#3d2412" stroke-width="2"/>
    <path d="M26 9 Q32 18 38 9" fill="none" stroke="#3d2412" stroke-width="2"/>
    <path d="M22 30 L42 30 M21 40 L43 40" stroke="#4a2c14" stroke-width="2.4"/>
    <rect x="29" y="27" width="6" height="6" rx="1" fill="url(#gold)" stroke="#5a3a10"/>
    <rect x="29" y="37" width="6" height="6" rx="1" fill="url(#gold)" stroke="#5a3a10"/>`,
  'life-crystal': `
    <path d="M32 6 L49 24 L32 58 L15 24 Z" fill="#7ff0a8" stroke="#16592e" stroke-width="2"/>
    <path d="M32 6 L39 24 L32 58 L25 24 Z" fill="#c6ffd9" opacity="0.7"/>
    <path d="M15 24 L49 24" stroke="#16592e" stroke-width="1.6"/>
    <path d="M22 14 L27 10" stroke="#fff" stroke-width="2.4" stroke-linecap="round"/>
    <path d="M47 46 h8 M51 42 v8" stroke="#eafff0" stroke-width="2.6" stroke-linecap="round"/>`,
  'swift-boots': `
    <path d="M22 10 L36 10 L36 38 Q46 40 52 46 L52 54 L14 54 L14 46 L22 42 Z" fill="url(#leather)" stroke="#3d2412" stroke-width="2"/>
    <path d="M14 50 L52 50" stroke="#3d2412" stroke-width="2"/>
    <path d="M36 16 Q48 8 58 12 Q50 16 56 20 Q46 20 50 26 Q42 24 36 26 Z" fill="#ffffff" stroke="#9fb3c8" stroke-width="1.4"/>
    <path d="M8 30 h8 M5 38 h10" stroke="#fff6c8" stroke-width="2.4" stroke-linecap="round" opacity="0.85"/>`,
  'agile-gloves': `
    <path d="M20 54 L20 34 Q16 28 18 22 L22 22 L24 30 L24 12 Q24 9 27 9 Q30 9 30 12 L30 26 L31 9 Q31 6 34 6 Q37 6 37 9 L37 26 L39 11 Q39 8 42 8 Q45 8 45 11 L44 30 L48 22 Q51 20 53 23 L46 42 L44 54 Z" fill="url(#gold)" stroke="#6a440f" stroke-width="2"/>
    <rect x="18" y="46" width="28" height="9" rx="2" fill="url(#leather)" stroke="#3d2412" stroke-width="1.8"/>
    <path d="M6 18 l6 4 M4 28 h7 M6 38 l6 -3" stroke="#fff" stroke-width="2.2" stroke-linecap="round" opacity="0.8"/>`,
  'time-amulet': `
    <path d="M20 6 Q32 20 44 6" fill="none" stroke="url(#gold)" stroke-width="3"/>
    <circle cx="32" cy="38" r="18" fill="url(#gold)" stroke="#5a3a10" stroke-width="2"/>
    <circle cx="32" cy="38" r="13" fill="#2a1f4a" stroke="#c9a2ff" stroke-width="1.6"/>
    <path d="M32 38 L32 29 M32 38 L39 41" stroke="#f3e8ff" stroke-width="2.6" stroke-linecap="round"/>
    <circle cx="32" cy="38" r="2" fill="#f3e8ff"/>
    <path d="M32 26 v2 M44 38 h-2 M32 50 v-2 M20 38 h2" stroke="#c9a2ff" stroke-width="2"/>`,
  'regen-ring': `
    <ellipse cx="32" cy="40" rx="18" ry="14" fill="none" stroke="url(#gold)" stroke-width="6"/>
    <ellipse cx="32" cy="40" rx="18" ry="14" fill="none" stroke="#5a3a10" stroke-width="1.2"/>
    <path d="M32 10 L42 22 L32 32 L22 22 Z" fill="#8ff5c4" stroke="#145c3a" stroke-width="2"/>
    <path d="M32 10 L36 22 L32 32 L28 22 Z" fill="#e6fff2" opacity="0.6"/>
    <path d="M49 10 v10 M44 15 h10" stroke="#eafff4" stroke-width="3" stroke-linecap="round"/>`,
  'vampire-fang': `
    <path d="M16 8 Q32 14 48 8 Q46 30 36 52 Q33 58 31 52 Q20 30 16 8 Z" fill="#fbf6ea" stroke="#5c4a3a" stroke-width="2"/>
    <path d="M22 12 Q28 30 32 48" stroke="#ffffff" stroke-width="2.4" fill="none" opacity="0.8"/>
    <path d="M44 40 Q49 48 44 52 Q39 48 44 40 Z" fill="#e0213f" stroke="#7a0a1c" stroke-width="1.4"/>
    <path d="M50 26 Q53 31 50 33 Q47 31 50 26 Z" fill="#e0213f"/>`,
  'shadow-dagger': `
    <path d="M50 8 L56 14 L28 42 L22 36 Z" fill="#cfc6ff" stroke="#2a2250" stroke-width="1.6"/>
    <path d="M52 10 L30 38" stroke="#ffffff" stroke-width="1.6" opacity="0.7"/>
    <path d="M18 32 L32 46 L29 49 L15 35 Z" fill="#4b3d8f" stroke="#1d1640" stroke-width="1.6"/>
    <path d="M22 42 L10 54" stroke="#2a2250" stroke-width="6" stroke-linecap="round"/>
    <path d="M8 22 Q4 32 12 40 M14 12 Q8 20 12 26" stroke="#9a8cff" stroke-width="2.4" fill="none" stroke-linecap="round" opacity="0.8"/>`,
  'helm-breaker': `
    <path d="M30 22 L36 22 L37 58 L29 58 Z" fill="url(#leather)" stroke="#3d2412" stroke-width="1.8"/>
    <rect x="12" y="8" width="40" height="18" rx="3" fill="${METAL}" stroke="#2b3542" stroke-width="2"/>
    <path d="M12 12 L6 10 L6 24 L12 22 Z M52 12 L58 10 L58 24 L52 22 Z" fill="#8a97a8" stroke="#2b3542" stroke-width="1.6"/>
    <path d="M16 12 h32" stroke="#fff" stroke-width="2" opacity="0.6"/>
    <rect x="28" y="40" width="10" height="5" fill="url(#gold)" stroke="#5a3a10"/>`,
  'stone-heart': `
    <path d="M32 56 L10 32 Q2 20 12 12 Q22 6 32 17 Q42 6 52 12 Q62 20 54 32 Z" fill="#9db4c8" stroke="#33465a" stroke-width="2.2"/>
    <path d="M22 20 L28 30 L22 38 M40 18 L36 30 L44 36 M30 40 L33 48" stroke="#4d6378" stroke-width="2" fill="none" stroke-linecap="round"/>
    <path d="M15 20 Q18 14 24 15" stroke="#fff" stroke-width="2.4" fill="none" stroke-linecap="round" opacity="0.75"/>`,
  'hero-blade': `
    <path d="M32 4 L38 12 L38 40 L26 40 L26 12 Z" fill="${METAL}" stroke="#2b3542" stroke-width="1.6"/>
    <path d="M32 6 L32 40" stroke="#fff" stroke-width="1.6" opacity="0.7"/>
    <path d="M14 40 Q32 34 50 40 L48 46 Q32 42 16 46 Z" fill="#3c5fd0" stroke="#1b2b66" stroke-width="1.6"/>
    <path d="M24 42 L32 36 L40 42 L32 48 Z" fill="url(#gold)" stroke="#5a3a10" stroke-width="1.2"/>
    <rect x="29" y="47" width="6" height="11" rx="2" fill="#2a3f8f" stroke="#141f4a"/>
    <path d="M10 10 l3 3 M54 10 l-3 3 M8 26 h4 M56 26 h-4" stroke="#fff6c8" stroke-width="2.2" stroke-linecap="round"/>`,
  'koopa-shell': `
    <ellipse cx="32" cy="38" rx="24" ry="16" fill="#f5ecd2" stroke="#6b5a32" stroke-width="2"/>
    <path d="M10 36 Q12 14 32 12 Q52 14 54 36 Q42 42 32 42 Q22 42 10 36 Z" fill="#4fae3c" stroke="#1f4a17" stroke-width="2"/>
    <path d="M26 20 L38 20 L42 30 L32 36 L22 30 Z" fill="#7ad05f" stroke="#1f4a17" stroke-width="1.6"/>`,
};

const cache = new Map<string, string>();

/** URL `data:` con la ilustración del objeto (o '' si no existe). */
export function itemIconUrl(id: string): string {
  let url = cache.get(id);
  if (url !== undefined) return url;
  const item = ITEMS[id];
  const art = ART[id];
  if (!item || !art) {
    cache.set(id, '');
    return '';
  }
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><defs>${DEFS}
    <radialGradient id="bg" cx="0.35" cy="0.3" r="0.9"><stop offset="0" stop-color="${item.color}" stop-opacity="0.55"/><stop offset="1" stop-color="#0d1520"/></radialGradient></defs>
    <rect width="64" height="64" rx="10" fill="url(#bg)"/>
    <g filter="url(#shadow)">${art}</g></svg>`;
  url = `data:image/svg+xml,${encodeURIComponent(svg)}`;
  cache.set(id, url);
  return url;
}
